var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadioCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.05112 5.79518L8.72166 0.124699C8.88872 -0.0424205 9.16303 -0.0407101 9.32844 0.124699L9.87592 0.672178C10.0413 0.837587 10.0413 1.11361 9.87592 1.27895L4.20544 6.94949C4.04003 7.1149 3.76572 7.11661 3.5986 6.94949L3.05112 6.40201C2.884 6.23489 2.884 5.9623 3.05112 5.79518Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.27887 2.33916L4.73308 5.79337C4.90014 5.96049 4.89817 6.23511 4.73308 6.40021L4.1856 6.94768C4.02051 7.11271 3.74386 7.11271 3.57877 6.94768L0.124557 3.49348C-0.0405356 3.32838 -0.0424995 3.05376 0.124557 2.88664L0.672036 2.33916C0.839155 2.1721 1.11175 2.1721 1.27887 2.33916Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioCheck);
export default __webpack_public_path__ + "static/media/radio-check.bf4ba52e98727239a2d8ba1c88f3b2f7.svg";
export { ForwardRef as ReactComponent };